import React from 'react';
import { TDropDownProp } from './Dropdown.types';
import { SDropdown } from './Dropdown.styles';

const Dropdown: React.FC<TDropDownProp> = props => {
  return <SDropdown {...props} />;
};

export default Dropdown;
